import Vue from 'vue';
import VuetifyToast from './toast';

Vue.use(VuetifyToast, {
  x: 'center', // default
  y: 'top', // default
  color: 'success', // default
  icon: 'mdi-check-circle-outline',
  iconColor: '', // default
  classes: [
    'body-2',
  ],
  timeout: 3000, // default
  dismissable: true, // default
  multiLine: false, // default
  vertical: false, // default
  queueable: true,
  showClose: false, // default
  closeText: '', // default
  closeIcon: 'close', // default
  closeColor: '', // default
  slot: [], // default
  shorts: {
    custom: {
      color: 'purple',
    },
  },
  property: '$toast', // default
});
